import React, {Component, useState} from 'react';
import Moment from 'moment';
import 'moment/locale/fr';
import axios from "axios";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import { confirmAlert } from 'react-confirm-alert';

import AuthService from "../../AuthService";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import frLocale from "date-fns/locale/fr";
import loader from "../../img/loader.gif";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class Calendriers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightTitleInactiveDate : 22,
            mode : 1,
            selectedVille:  (this.props.match.params.villeId == 1 || this.props.match.params.villeId === undefined  ? 1 : this.props.match.params.villeId),
            calendarType: '/getCalendar',
            displayForm: false,
            displayFormBlock: false,
            displayDetails: false,
            result: null,
            data: '',
            villeList: [],
            formDateInactive : {
                periodMap : {},
                maxInactivePeriod : 0,
                selectedInactiveId: -1,
                selectedInactiveDate: Moment(),
                selectedInactiveDateAllDay: false,
                selectedInactiveDateFrom: "",
                selectedInactiveDateTo: "",
            },
            formData: {
                date: new Date()
            },
            currentCroisiereToolTipId: null,
            isOpen: false,
            anchorId: null
        }
        this.previousWeek = this.previousWeek.bind(this);
        this.nextWeek = this.nextWeek.bind(this);
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.loadData();
        if (!!this.props.match.params.croisiereId && this.props.match.params.croisiereId > 0) {
            this.selectCroisiere(this.props.match.params.croisiereId);
        }
    }

    async loadData(newDate) {
        let date = !!newDate ? newDate : (!!this.props.match.params.croisiereDate && !!this.state.formData.date !== new Date()) ? Moment(this.props.match.params.croisiereDate, "DDMMYYYY") : this.state.formData.date;

        let startDate;
        if (this.state.mode === 1) {
            startDate = Moment(date).startOf('week');
        } else if (this.state.mode === 2) {
            startDate = date;
        }

        let endDate;
        if (this.state.mode === 1) {
            endDate = Moment(startDate).add(7, 'days');
        } else if (this.state.mode === 2) {
            endDate = startDate;
        }

        let allDays;
        if (this.state.mode === 1) {
            allDays = [
                startDate,
                Moment(startDate).add(1, 'days'),
                Moment(startDate).add(2, 'days'),
                Moment(startDate).add(3, 'days'),
                Moment(startDate).add(4, 'days'),
                Moment(startDate).add(5, 'days'),
                Moment(startDate).add(6, 'days')];
        } else if (this.state.mode === 2) {
            allDays = [startDate];
        }

        await axios.post(AuthService.getUrl('/getVilles'), {}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                villeList: res.data.data['list']
            });
        });

        await axios.post(AuthService.getUrl('/getWeeklyInactiveDate'), {date: startDate, villeId: this.state.selectedVille}, AuthService.getAuthHeader()).then(res => {
            this.setState(state => {
                const formDateInactive = state.formDateInactive;
                formDateInactive.maxInactivePeriod = res.data.data['list']['maxInactiveDatePeriod'];
                formDateInactive.periodMap = res.data.data['list']['periodMap'];
                return {formDateInactive: formDateInactive};
            });
        });

        await axios.post(AuthService.getUrl(this.state.calendarType), {
            villeId: this.state.selectedVille,
            date: Moment(date).format("DD/MM/YYYY"),
            croisiereId: this.state.selectedCroisireId
        }, AuthService.getAuthHeader()).then(res => {
            this.setState({
                result: res.return,
                data: res.data.data
            });
            this.setState({isLoading: false});
        });

        this.setState(state => {
            const formData = state.formData;
            formData.date = date;
            formData.startDate = startDate;
            formData.endDate = endDate;
            formData.dates = allDays;

            return {formData: formData};
        });
    }

    previousWeek() {
        this.setState({isLoading: true});
        this.setState({formError: null});
        this.setState({displayDetails: false});
        this.setState({displayForm: false});
        this.setState({displayFormBlock: false});
        if (this.state.mode === 1) {
            this.loadData(Moment(this.state.formData.date).subtract(7, 'days'));
        } else if (this.state.mode === 2) {
            this.loadData(Moment(this.state.formData.date).subtract(1, 'days'));
        }
    }

    nextWeek() {
        this.setState({isLoading: true});
        this.setState({formError: null});
        this.setState({displayDetails: false});
        this.setState({displayForm: false});
        this.setState({displayFormBlock: false});
        if (this.state.mode === 1) {
            this.loadData(Moment(this.state.formData.date).add(7, 'days'));
        } else if (this.state.mode === 2) {
            this.loadData(Moment(this.state.formData.date).add(1, 'days'));
        }
    }

    async selectCroisiere(croisiereId) {
        this.setState({formError: null});
        this.setState({selectedCroisireId: croisiereId});
        this.setState({displayForm: false});
        this.setState({displayFormBlock: false});
        this.setState({displayDetails: true});

        await axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState({currentCroisiereTooltip: this.state.data.croisieres?.filter((e) => e.id === croisiereId)[0]});
    }

    async selectCroisiereMouseOver(croisiereId) {
        await axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState({currentCroisiereTooltip: this.state.data.croisieres?.filter((e) => e.id === croisiereId)[0]});
        /*this.setState({formError: null});
        this.setState({displayForm: false});
*/
        /*this.setState({selectedCroisireId: croisiereId});*/
        /*axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState( {currentCroisiereTooltip: this.state.data.croisieres?.filter((e) => e.id === croisiereId)[0]});
        this.setState({displayDetails: true});
        ReactTooltip.rebuild();*/
    }

    async initCroisiere(croisiereId, date) {
        this.setState({formError: null});
        this.setState({displayDetails: false});
        this.setState({selectedCroisireId: croisiereId});
        this.setState({displayForm: true});
        this.setState({displayFormBlock: false});

        if (!!croisiereId) {
            await axios.post(AuthService.getUrl("/getCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState(state => {
                const formData = state.formData;
                formData.croisiereTypeId = res.data.data.croisiere.croisiereType.id;
                formData.croisiereTypeDuree = res.data.data.croisiere.croisiereType.duree;
                formData.croisiereDate = Moment(res.data.data.croisiere.date, "DD/MM/YYYY HH:mm");
                if (res.data.data.croisiere.bateau !== null) {
                    formData.croisiereBateauId = res.data.data.croisiere.bateau.id;
                }
                if (res.data.data.croisiere.utilisateur != null) {
                    formData.croisiereCapitaineId = !!res.data.data.croisiere.utilisateur ? res.data.data.croisiere.utilisateur.id : null;
                }
                return {formData: formData};
            }));

        } else {
            this.setState(state => {
                const formData = state.formData;
                formData.croisiereTypeId = "";
                formData.croisiereTypeDuree = "";
                formData.croisiereDate = date;
                formData.croisiereBateauId = "";
                formData.croisiereCapitaineId = "";
                return {formData: formData};
            });
            this.newCroisiereChange();
        }
    }

    async copyCroisiere(croisiereId, date) {
        this.setState({formError: null});
        this.setState({displayDetails: false});
        this.setState({selectedCroisireToCopyId: croisiereId});
        this.setState({displayForm: true});
        this.setState({displayFormBlock: false});
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereTypeId = "";
            formData.croisiereTypeDuree = "";
            formData.croisiereDate = date;
            formData.croisiereBateauId = "";
            formData.croisiereCapitaineId = "";
            return {formData: formData};
        });
        await this.newCroisiereChange();
    }

    typeChange(e) {
        e.preventDefault();
        let index = e.nativeEvent.target.selectedIndex;
        let duree = e.nativeEvent.target[index].getAttribute('data-duree');
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereTypeId = value;
            formData.croisiereTypeDuree = duree;
            return {formData: formData};
        });
        this.newCroisiereChange(null, null, duree);
    }

    async villeChange(e) {
        e.preventDefault();
        this.setState({isLoading: true, selectedCroisireId: undefined});
        let value = e.target.value;
        await this.setState({
            selectedVille: value
        });
        this.loadData();
        if (!!this.props.match.params.croisiereId) {
            this.selectCroisiere(this.props.match.params.croisiereId);
        }
    }

    bateauChange(e) {
        e.preventDefault();
        let index = e.nativeEvent.target.selectedIndex;
        let label = e.nativeEvent.target[index].text;
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereBateauId = value;
            formData.croisiereBateauName = label;
            return {formData: formData};
        });
        this.newCroisiereChange(value, null, null);
    }

    capitainechange(e) {
        e.preventDefault();
        let index = e.nativeEvent.target.selectedIndex;
        let label = e.nativeEvent.target[index].text;
        let value = e.target.value;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereCapitaineId = value;
            formData.croisiereCapitaineName = label;
            return {formData: formData};
        });
    }

    dateChange(date) {
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereDate = date;
            return {formData: formData};
        });
        this.loadData(date);
        this.newCroisiereChange(null, date, null);
    }

    async newCroisiereChange(croisiereBateauId, croisiereDate, croisiereTypeDuree) {
        this.setState({formError: null});

        let croisiereId = !!this.state.selectedCroisireId ? this.state.selectedCroisireId : "";
        croisiereBateauId = !!croisiereBateauId ? croisiereBateauId : this.state.formData.croisiereBateauId;
        croisiereDate = !!croisiereDate ? croisiereDate : this.state.formData.croisiereDate;
        croisiereTypeDuree = !!croisiereTypeDuree ? croisiereTypeDuree : this.state.formData.croisiereTypeDuree;

        if (!!croisiereBateauId && !!croisiereDate && !!croisiereTypeDuree) {

            var data = {
                croisiereId: croisiereId,
                bateauId: croisiereBateauId,
                date: Moment(croisiereDate).format("DD/MM/YYYY HH:mm"),
            };

            if (croisiereTypeDuree != 'null') {
                data.duree = croisiereTypeDuree
            }

            await axios.post(AuthService.getUrl("/getCollisionByDate"), data,
                AuthService.getAuthHeader()).then(res => this.setState({
                formError: res.data.data.message
            }));
        }
    }

    async saveDateInactive(e) {
        e.preventDefault();
        let valid = true;
        if (this.state.formDateInactive.selectedInactiveDateAllDay == false) {
            if (this.state.formDateInactive.selectedInactiveDateFrom == '' || this.state.formDateInactive.selectedInactiveDateFrom == '') {
                valid = false;
            }
        }

        if (valid) {
            await axios.post(AuthService.getUrl('/saveInactiveDate'), {
                inactiveDateResult: {
                    dateStr: Moment(this.state.formDateInactive.selectedInactiveDate).format('DD/MM/YYYY'),
                    allDay: this.state.formDateInactive.selectedInactiveDateAllDay,
                    begin: this.state.formDateInactive.selectedInactiveDateFrom,
                    end: this.state.formDateInactive.selectedInactiveDateTo,
                    villeId: this.state.selectedVille,
                }
            }, AuthService.getAuthHeader()).then(res => {
               if (res.data.data.response.code === 200) {
                   document.location = "/admin/calendriers/" + this.state.selectedVille + "/0/" + Moment(this.state.formDateInactive.selectedInactiveDate, 'DD/MM/YYYY HH:mm').format('DDMMYYYY');
               } else {
                   this.setState({formError: res.data.data.response.message});
               }
            });
        }
        else {
            this.setState({formError: "Information manquante"});
        }

    }

    async confirmDeleteIntervalInactiveDate(e, date) {
        e.preventDefault();
        const options = {
            title: 'Confirmation',
            message: 'Êtes-vous sur de vouloir supprimer ce(s) créneau(x) inactif(s)?',
            buttons: [
                {
                    label: 'Oui',
                    onClick: () => this.deleteIntervalInactiveDate(date)
                },
                {
                    label: 'Non'
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            willUnmount: () => {},
            afterClose: () => {},
            onClickOutside: () => {},
            onKeypress: () => {},
            onKeypressEscape: () => {},
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)
    }

    async deleteIntervalInactiveDate(date) {
        await axios.post(AuthService.getUrl('/deleteInactiveDate'), {
            inactiveDateResult: {
                dateStr: Moment(date).format('DD/MM/YYYY'),
                villeId : this.state.selectedVille,
            }
        }, AuthService.getAuthHeader()).then(res => {
            document.location = "/admin/calendriers/" + this.state.selectedVille + "/0/" + Moment(date, 'DD/MM/YYYY HH:mm').format('DDMMYYYY');
        });
    }

    async saveCroisiere(e) {
        e.preventDefault();
        if (!!this.state.selectedCroisireId && !this.state.selectedCroisireToCopyId) {
            await axios.post(AuthService.getUrl('/saveCroisire'), {
                croisiere: {
                    id: this.state.selectedCroisireId,
                    date: Moment(this.state.formData.croisiereDate, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm:ss'),
                    croisiereType: {
                        id: this.state.formData.croisiereTypeId
                    },
                    bateau: {
                        id: this.state.formData.croisiereBateauId
                    },
                    utilisateur: {
                        id: this.state.formData.croisiereCapitaineId
                    }
                }
            }, AuthService.getAuthHeader()).then(res => {
                document.location = "/admin/calendriers/" + this.state.selectedVille + "/" + this.state.selectedCroisireId + "/" + Moment(this.state.formData.croisiereDate, 'DD/MM/YYYY HH:mm').format('DDMMYYYY');
            });
        } else if (!this.state.selectedCroisireToCopyId && !!this.state.formData.croisiereTypeId && !!this.state.formData.croisiereTypeDuree && this.state.formData.croisiereBateauId && !!this.state.formData.croisiereBateauName && !!this.state.formData.croisiereDate) {
            if (!!this.state.formData.croisiereCapitaineId) {
                document.location = "/admin/croisiere/ /" + this.state.formData.croisiereTypeId + "/" + this.state.formData.croisiereTypeDuree + "/" + this.state.formData.croisiereBateauId + "/" + this.state.formData.croisiereBateauName  + "/" + encodeURIComponent(Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY HH:mm")) + "/-1/" + this.state.formData.croisiereCapitaineId + "/" + this.state.formData.croisiereCapitaineName;
            } else {
                document.location = "/admin/croisiere/ /" + this.state.formData.croisiereTypeId + "/" + this.state.formData.croisiereTypeDuree + "/" + this.state.formData.croisiereBateauId + "/" + this.state.formData.croisiereBateauName  + "/" + encodeURIComponent(Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY HH:mm")) + "/"
            }
        } else if (!!this.state.selectedCroisireToCopyId && !!this.state.formData.croisiereTypeId && !!this.state.formData.croisiereTypeDuree && this.state.formData.croisiereBateauId && !!this.state.formData.croisiereBateauName && !!this.state.formData.croisiereDate) {
            if (!!this.state.formData.croisiereCapitaineId) {
                document.location = "/admin/croisiere/ /" + this.state.formData.croisiereTypeId + "/" + this.state.formData.croisiereTypeDuree + "/" + this.state.formData.croisiereBateauId + "/" + this.state.formData.croisiereBateauName + "/" + encodeURIComponent(Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY HH:mm")) + "/" + this.state.selectedCroisireToCopyId + "/" + this.state.formData.croisiereCapitaineId + "/" + this.state.formData.croisiereCapitaineName;
            } else {
                document.location = "/admin/croisiere/ /" + this.state.formData.croisiereTypeId + "/" + this.state.formData.croisiereTypeDuree + "/" + this.state.formData.croisiereBateauId + "/" + this.state.formData.croisiereBateauName + "/" + encodeURIComponent(Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY HH:mm")) + "/" + this.state.selectedCroisireToCopyId + "/"
            }
        }
        else {
            this.setState({formError: "Information croisière manquante"});
        }

    }

    showInactiveDateForm() {
        this.setState({displayForm: false});
        this.setState({displayFormBlock: true});
    }

    selectedInactiveDateAllDayChange() {
        this.setState(state => {
            const formDateInactive = state.formDateInactive;
            formDateInactive.selectedInactiveDateAllDay = !this.state.formDateInactive.selectedInactiveDateAllDay;
            if (formDateInactive.selectedInactiveDateAllDay == true) {
                formDateInactive.selectedInactiveDateFrom = "";
                formDateInactive.selectedInactiveDateTo = "";
            }
            return {formDateInactive: formDateInactive};
        });
    }

    selectedInactiveDateChange(date) {
        this.setState(state => {
            const formDateInactive = state.formDateInactive;
            formDateInactive.selectedInactiveDate = date;
            return {formDateInactive: formDateInactive};
        });
    }

    selectedInactiveDateFromChange(e) {
        e.preventDefault();

        let value = e.target.value;
        this.setState(state => {
            const formDateInactive = state.formDateInactive;
            formDateInactive.selectedInactiveDateFrom = value;
            return {formDateInactive: formDateInactive};
        });
    }

    selectedInactiveDateToChange(e) {
        e.preventDefault();
        let value = e.target.value;
        this.setState(state => {
            const formDateInactive = state.formDateInactive;
            formDateInactive.selectedInactiveDateTo = value;
            return {formDateInactive: formDateInactive};
        });
    }

    getColumnStyle(index) {
        let style = {};
        let height = 1241 + (this.state.formDateInactive.maxInactivePeriod * 14);
        return {
            left: "calc(" + index + " * 14.28%)",
            height: height,
        };
    }

    getCalendarBoxStyle() {
        let style = {};
        let height = 1217 + (this.state.formDateInactive.maxInactivePeriod * 14) + this.state.heightTitleInactiveDate;
        return {
            height: height,
        };
    }

    getColumnStyleInactiveDate(date) {
        let style = {};
        let visible = this.state.formDateInactive.periodMap[Moment(date).format('DD/MM/YYYY')] != null;

        if (!visible) {
            style = {
                display: "none",
            };
        } else {
            let height = this.state.heightTitleInactiveDate + (this.state.formDateInactive.maxInactivePeriod * 14);

            style = {
                height: height + "px",
            };
        }
        return style;
    }

    getPeriods(date) {
        let period = "";
        let mydate = date.format("DD/MM/YYYY");

        if (this.state.formDateInactive.periodMap[mydate]!=null) {
            this.state.formDateInactive.periodMap[mydate].forEach((opt, index) => {
                period += " de " + opt.begin + " à " + opt.end + "\n";
            })
        }
        return period;
    }

    getColumnStyleColumnTitle(date) {
        let style = {};
        let color = null;
        if ((Moment(date).format("DD/MM/YYYY") === Moment(new Date()).format("DD/MM/YYYY"))) {
            color = "#FF0000";
        }

        let visible = this.state.formDateInactive.periodMap[Moment(date).format('DD/MM/YYYY')] != null;

        if (!visible) {
            let top = -68 + (this.state.heightTitleInactiveDate + (this.state.formDateInactive.maxInactivePeriod * 14));
            if (color!=null) {
                style = {
                    top: top + "px",
                    color: color,
                };
            } else {
                style = {
                    top: top + "px",
                };
            }
        } else {
            if (color!=null) {
                style = {
                    color: color,
                };
            }

        }
        return style;
    }

    getCalendarHsStyle(hr) {
        let style = { };
        let top = (hr * 50) + (this.state.formDateInactive.maxInactivePeriod * 14) + ((this.state.heightTitleInactiveDate / 2) -  3);
        style = {
            top: top,
        };
        return style;
    }

    getColumnClass() {
        if (this.state.mode === 1) {
            return "calendar-column";
        } else if (this.state.mode === 2) {
            return "calendar-column-daily";
        }
    }

    getCroisiereClass(croisiereId) {
        if (croisiereId == this.state.selectedCroisireId) {
            return "croisiereseleted";
        } else {
            return "";
        }
    }

    getItemStyle(croisiere) {
        let style = {};
        let date = null;
        let bateauId = null;
        let duree = null;
        let background = null;
        let delaiBefore = 0;
        let delaiAfter = 0;

        if (!!croisiere) {
            if (this.state.displayForm && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id) {
                date = new Date(this.state.formData.croisiereDate);
                bateauId = this.state.formData.croisiereBateauId;
                duree = this.state.formData.croisiereTypeDuree;
                //background = "repeating-linear-gradient(45deg, " + croisiere.bateau.planningColor + ", " + croisiere.bateau.planningColor + " 10px, #000000 10px, #000000 20px)"
                background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
            } else {
                date = new Date(Moment(croisiere.date, "DD/MM/YYYY HH:mm").format());
                bateauId = croisiere.bateau.id;
                duree = croisiere.croisiereType.duree;
                background = croisiere.bateau.planningColor;
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            }
        } else {
            date = new Date(this.state.formData.croisiereDate);
            bateauId = this.state.formData.croisiereBateauId;
            duree = this.state.formData.croisiereTypeDuree;
            background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
        }

        let hour = date.getHours();
        let min = date.getMinutes();

        let left = "90%";
        /*if (!!bateauId) {
            if (bateauId > 10)
                left = "calc(" + (bateauId / 10 - 1) + " * 10%)";
            else
                left = "calc(" + (bateauId - 1) + " * 10%)";
        }*/
        let pixelTop = hour;
        if (min === 30) {
            pixelTop += 0.5;
        } else if (min === 15) {
            pixelTop += 0.25;
        } else if (min === 45) {
            pixelTop += 0.75;
        } else {
            pixelTop += 0;
        }

        let pixelDelai = 0;
        if (delaiBefore === 30) {
            pixelDelai += 0.5;
        } else if (pixelDelai === 15) {
            pixelDelai += 0.25;
        } else if (pixelDelai === 45) {
            pixelDelai += 0.75;
        } else {
            pixelDelai += 0;
        }

        if (delaiBefore > 0) {
            delaiBefore -= 5;
        }

        style = {
            width: "100%",
            height: 49 * duree + "px",
            background: background,
            top: (pixelTop * 47) - (pixelTop * 47) + delaiBefore + "px"
            /*left: left,
            top: pixelTop * 50 + "px",
            width: "9%",
            height: 50 * duree + "px",
            //lineHeight: 50 * duree + "px",
            background: background*/
        };

        return style;
    }

    getBorderStyle(croisiere) {
        let style = {};
        let date = null;
        let bateauId = null;
        let duree = null;
        let background = null;
        let delaiBefore = 0;
        let delaiAfter = 0;

        if (!!croisiere) {
            if (this.state.displayForm && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id) {
                date = new Date(this.state.formData.croisiereDate);
                bateauId = this.state.formData.croisiereBateauId;
                duree = this.state.formData.croisiereTypeDuree;
                //background = "repeating-linear-gradient(45deg, " + croisiere.bateau.planningColor + ", " + croisiere.bateau.planningColor + " 10px, #000000 10px, #000000 20px)"
                background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            } else {
                date = new Date(Moment(croisiere.date, "DD/MM/YYYY HH:mm").subtract(croisiere.delaiBefore, 'm').format());
                bateauId = croisiere.bateau.id;
                duree = croisiere.croisiereType.duree;
                background = croisiere.bateau.planningColor;
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            }
        } else {
            date = new Date(this.state.formData.croisiereDate);
            bateauId = this.state.formData.croisiereBateauId;
            duree = this.state.formData.croisiereTypeDuree;
            background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
        }

        let hour = date.getHours();
        let min = date.getMinutes();
        let height = (47 * duree + duree * 2 - 1) + delaiBefore + delaiAfter;

        let left = "90%";
        if (!!bateauId) {
            /* Paris */
            if (bateauId == 5) {
                left = "calc(0%)";
            } else if (bateauId == 2) {
                left = "calc(10%)";
            } else if (bateauId == 3) {
                left = "calc(20%)";
            } else if (bateauId == 8) {
                left = "calc(30%)";
            } else if (bateauId == 42) {
                left = "calc(40%)";
            } else if (bateauId == 4) {
                left = "calc(50%)";
            } else if (bateauId == 6) {
                left = "calc(60%)";
            } else if (bateauId == 7) {
                left = "calc(70%)";
            } else if (bateauId == 43) {
                left = "calc(80%)";
            }
            /* Nogent */
            else if (bateauId == 1) {
                left = "calc(0%)";
            } else if (bateauId == 33) {
                left = "calc(10%)";
            } else if (bateauId == 34) {
                left = "calc(20%)";
            } else if (bateauId == 35) {
                left = "calc(30%)";
            }
        }
        let pixelTop = hour;
        if (min === 30) {
            pixelTop += 0.5;
        } else if (min === 15) {
            pixelTop += 0.25;
        } else if (min === 45) {
            pixelTop += 0.75;
        } else {
            pixelTop += 0;
        }

        if (delaiBefore > 0) {
            height -= 5;
        }
        if (delaiAfter > 0) {
            height -= 5;
        }

        console.log(pixelTop)
        pixelTop = pixelTop * 50 + (this.state.formDateInactive.maxInactivePeriod * 14) + 22;
        console.log(pixelTop)

        style = {
            left: left,
            top: pixelTop + "px",
            width: "9%",
            height: height + "px",
            border: '3px solid rgba(0, 0, 0, 1)'
        };

        return style;
    }

    selectCroisiereUi(croisiereId) {
        if (!!croisiereId) {
            var elements = document.getElementsByClassName("calendar-item");
            var count = elements.length;
            for (var i=0; i<count; i++) {
                elements[i].classList.remove("croisiereseleted");
            }
            document.getElementById('calendarDiv' + croisiereId).classList.add("croisiereseleted");
        }
    }

    changeMode = (newmode) => {
        if (this.state.mode === 1) {
            this.setState({mode: 2}, this.loadData)
        } else {
            this.setState({mode: 1}, this.loadData)
        }
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div className="box">
                    <div className="boxTitle">Calendrier</div>
                    <div className="boxContent">
                        <div className="calendarSelector">
                            {<select className="value" type="text" name="villes" value={this.state.selectedVille}
                                     onChange={e => this.villeChange(e)}>
                                {this.state.villeList.map(ville => (
                                    <option key={ville.id} value={ville.id}>{ville.nom}</option>
                                ))}
                            </select>}

                            {this.state.mode === 1 &&
                                <button className="coreBlockItem-typeSubmitSearch" style={{"width" : "150px"}} onClick={this.changeMode}>Vue journalière</button>
                            }
                            {this.state.mode === 2 &&
                                <button className="coreBlockItem-typeSubmitSearch" style={{"width" : "150px"}} onClick={this.changeMode}>Vue hebdomadaire</button>
                            }
                            <div className="calendarPrevious" onClick={e => this.previousWeek(e)}></div>
                            <div className="calendarCurrent">
                                {this.state.mode === 1 &&
                                <div>
                                    Semaine {Moment(this.state.formData.date).isoWeek()}<br/>
                                    {Moment(this.state.formData.startDate).format("DD/MM/YYYY")} au {Moment(this.state.formData.endDate).format("DD/MM/YYYY")}
                                </div>
                                }
                                {this.state.mode === 2 &&
                                <div>
                                    {Moment(this.state.formData.startDate).format("DD MMMM YYYY")}
                                </div>
                                }
                            </div>
                            <div className="calendarNext" onClick={e => this.nextWeek(e)}></div>
                        </div>

                        <div>
                            <img id="inactiveDateButt" onClick={e => this.showInactiveDateForm(e)} />
                        </div>

                        <div id="calendar">
                            {this.state.displayDetails &&
                            <div id="calendar-details" className="box">
                                {this.state.data.croisieres.map(croisiere => (
                                    <React.Fragment>
                                        {croisiere.id == this.state.selectedCroisireId &&
                                        <React.Fragment>
                                            <div
                                                className={"boxTitle croisiereStatut-" + croisiere.refCroisiereStatut.id}>CROISIERE
                                                #{croisiere.id}</div>
                                            <div className="boxContent">
                                                <div id="infoIcon-1"
                                                     className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}</div>
                                                <br/>
                                                <div id="infoIcon-2"
                                                     className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("HH:mm")}</div>
                                                <br/>
                                                <div id="infoIcon-3"
                                                     className="infoIcon">{!!croisiere.bateau ? croisiere.bateau.nom : ""}</div>
                                                <br/>
                                                <div id="infoIcon-4"
                                                     className="infoIcon">{!!croisiere.utilisateur ? croisiere.utilisateur.fullName : ""}</div>
                                                <br/><br/>
                                                {this.state.formError &&
                                                <ul className="errorMessage alignCenter">
                                                    <li><span>{this.state.formError}</span></li>
                                                </ul>
                                                }
                                                <div className="alignCenter">
                                                    {croisiere.refCroisiereStatut.id < 5 &&
                                                    <button type="button" className="validButton"
                                                            style={{width: "100%", marginBottom: "10px"}}
                                                            onClick={e => this.initCroisiere(this.state.selectedCroisireId, null)}>Modifier planning</button>
                                                    }
                                                    {croisiere.refCroisiereStatut.id == 8 &&
                                                    <button type="button" className="validButton"
                                                            style={{width: "100%", marginBottom: "10px"}}
                                                            onClick={e => this.initCroisiere(this.state.selectedCroisireId, null)}>Modifier planning</button>
                                                    }
                                                    <button type="button" className="validButton"
                                                            style={{width: "100%", marginBottom: "10px"}}
                                                            onClick={e => document.location = "/admin/croisiere/" + croisiere.id}>Voir
                                                        détails
                                                    </button>
                                                    <button type="button" className="validButton"
                                                            style={{width: "100%"}}
                                                            onClick={e => this.copyCroisiere(this.state.selectedCroisireId, null)}>Dupliquer
                                                    </button>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                            }
                            {this.state.displayForm &&
                            <div id="calendar-form" className="box">
                                <div className="boxTitle"
                                     style={{background: "#32455A"}}>{!!this.state.selectedCroisireId ? "Edition croisière #" + this.state.selectedCroisireId : "Nouvelle croisière"}</div>
                                <form className="boxContent" onSubmit={e => this.saveCroisiere(e)}>
                                    {this.state.formError &&
                                    <ul className="errorMessage alignCenter">
                                        <li><span>{this.state.formError}</span></li>
                                    </ul>
                                    }
                                    <div className="label">Date croisière</div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                        <DateTimePicker name="croisiereDate"
                                                        value={this.state.formData.croisiereDate}
                                                        onChange={date => this.dateChange(date)}
                                                        className="materialUiPicker"
                                                        ampm={false}
                                                        disableToolbar={true}
                                            //views={["day", "hours", "minutes"]}
                                                        format="dd/MM/yyyy HH:mm"
                                                        inputVariant="outlined"
                                                        minutesStep={15}/>
                                    </MuiPickersUtilsProvider>

                                    <div className="label">Type</div>
                                    <select className="value" type="text" name="croisiereTypeId"
                                            value={this.state.formData.croisiereTypeId}
                                            onChange={e => this.typeChange(e)}
                                            style={{width: "100%"}}>
                                        <option data-duree="null" value="null"></option>
                                        {this.state.data.croisiereTypes.map(type => (
                                            <option key={type.id} value={type.id}
                                                    data-duree={type.duree}>{type.label}</option>
                                        ))}
                                    </select>

                                    <div className="label">Bateau</div>
                                    <select className="value" type="text" name="croisiereBateauId"
                                            value={this.state.formData.croisiereBateauId}
                                            onChange={e => this.bateauChange(e)}
                                            style={{width: "300px"}}>
                                        <option value=""></option>
                                        {this.state.data.bateaux.map(bateau => (
                                            <option key={bateau.id} value={bateau.id}>{bateau.nom}</option>
                                        ))}
                                    </select>

                                    <div className="label">Capitaine</div>
                                    <select className="value" type="text" name="croisiereCapitaineId"
                                            value={this.state.formData.croisiereCapitaineId}
                                            onChange={e => this.capitainechange(e)}
                                            style={{width: "300px"}}>
                                        <option value=""></option>
                                        {this.state.data.utilisateurs.map(utilisateur => (
                                            <option key={utilisateur.id}
                                                    value={utilisateur.id}>{utilisateur.prenom} {utilisateur.nom}</option>
                                        ))}
                                    </select>

                                    <div className="alignCenter">
                                        <button type="button" className="backButton" style={{marginRight: "20px"}}
                                                onClick={e => this.setState({displayForm: false})}>ANNULER
                                        </button>
                                        <button type="submit" className="validButton">VALIDER</button>
                                    </div>
                                </form>
                            </div>
                            }
                            {this.state.displayFormBlock &&
                            <div id="calendar-form" className="box">
                                <div className="boxTitle"
                                     style={{background: "#32455A"}}>Date inactive</div>
                                <form className="boxContent" onSubmit={e => this.saveDateInactive(e)}>
                                    {this.state.formError &&
                                    <ul className="errorMessage alignCenter">
                                        <li><span>{this.state.formError}</span></li>
                                    </ul>
                                    }
                                    <div className="label">Date inactive</div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                                        <DateTimePicker name="selectedInactiveDate"
                                                        value={this.state.formDateInactive.selectedInactiveDate}
                                                        onChange={date => this.selectedInactiveDateChange(date)}
                                                        className="materialUiPicker"
                                                        ampm={false}
                                                        disableToolbar={true}
                                                        views={["date"]}
                                                        format="dd/MM/yyyy"
                                                        inputVariant="outlined" />
                                    </MuiPickersUtilsProvider>

                                    <input type="checkbox" id="allDay" name="allDay" checked={this.state.formDateInactive.selectedInactiveDateAllDay}
                                               value={this.state.formDateInactive.selectedInactiveDateAllDay}
                                               onChange={e => this.selectedInactiveDateAllDayChange(e)}/>
                                    <label htmlFor="allDay"> Toute la journée</label><br/><br/>

                                    <div className="label">De</div>
                                    <select className="value" type="text" name="inactiveDateFrom"
                                            value={this.state.formDateInactive.selectedInactiveDateFrom} disabled={this.state.formDateInactive.selectedInactiveDateAllDay}
                                            onChange={e => this.selectedInactiveDateFromChange(e)}
                                            style={{width: "300px"}}>
                                        <option value=""></option>
                                        <option value="09:00">09:00</option>
                                        <option value="09:30">09:30</option>
                                        <option value="10:00">10:00</option>
                                        <option value="10:30">10:30</option>
                                        <option value="11:00">11:00</option>
                                        <option value="11:30">11:30</option>
                                        <option value="12:00">12:00</option>
                                        <option value="12:30">12:30</option>
                                        <option value="13:00">13:00</option>
                                        <option value="13:30">13:30</option>
                                        <option value="14:00">14:00</option>
                                        <option value="14:30">14:30</option>
                                        <option value="15:00">15:00</option>
                                        <option value="15:30">15:30</option>
                                        <option value="16:00">16:00</option>
                                        <option value="16:30">16:30</option>
                                        <option value="17:00">17:00</option>
                                        <option value="17:30">17:30</option>
                                        <option value="18:00">18:00</option>
                                        <option value="18:30">18:30</option>
                                        <option value="19:00">19:00</option>
                                        <option value="19:30">19:30</option>
                                        <option value="20:00">20:00</option>
                                        <option value="20:30">20:30</option>
                                        <option value="21:00">21:00</option>
                                        <option value="21:30">21:30</option>
                                    </select>

                                    <div className="label">A</div>
                                    <select className="value" type="text" name="inactiveDateTo"
                                            value={this.state.formDateInactive.selectedInactiveDateTo} disabled={this.state.formDateInactive.selectedInactiveDateAllDay}
                                            onChange={e => this.selectedInactiveDateToChange(e)}
                                            style={{width: "300px"}}>
                                        <option value=""></option>
                                        <option value="09:00">09:00</option>
                                        <option value="09:30">09:30</option>
                                        <option value="10:00">10:00</option>
                                        <option value="10:30">10:30</option>
                                        <option value="11:00">11:00</option>
                                        <option value="11:30">11:30</option>
                                        <option value="12:00">12:00</option>
                                        <option value="12:30">12:30</option>
                                        <option value="13:00">13:00</option>
                                        <option value="13:30">13:30</option>
                                        <option value="14:00">14:00</option>
                                        <option value="14:30">14:30</option>
                                        <option value="15:00">15:00</option>
                                        <option value="15:30">15:30</option>
                                        <option value="16:00">16:00</option>
                                        <option value="16:30">16:30</option>
                                        <option value="17:00">17:00</option>
                                        <option value="17:30">17:30</option>
                                        <option value="18:00">18:00</option>
                                        <option value="18:30">18:30</option>
                                        <option value="19:00">19:00</option>
                                        <option value="19:30">19:30</option>
                                        <option value="20:00">20:00</option>
                                        <option value="20:30">20:30</option>
                                        <option value="21:00">21:00</option>
                                        <option value="21:30">21:30</option>
                                    </select>

                                    <div className="alignCenter">
                                        <button type="button" className="backButton" style={{marginRight: "20px"}}
                                                onClick={e => this.setState({displayFormBlock: false})}>ANNULER
                                        </button>
                                        <button type="submit" className="validButton">VALIDER</button>
                                    </div>
                                </form>
                            </div>
                            }

                            <div id="calendar-box" style={this.getCalendarBoxStyle()}>
                                {this.state.isLoading &&
                                <img src={loader} alt="loading"
                                     style={{"display": "block", "margin": "50px auto"}}/>
                                }
                                {this.state.formData?.dates?.map((date, index) => (
                                    <div className={this.getColumnClass()} style={this.getColumnStyle(index)}>
                                        <div className="calendar-column-inactive-date" style={this.getColumnStyleInactiveDate(date)}>
                                            <table style={{ "border": "none", "border-spacing" : " 0px", "width" : "100%"}}>
                                                <tr>
                                                   <td style={{"text-align" : "left"}}><span style={{"font-size": "12px","font-weight": "bold"}}>Date inactive</span></td>
                                                   <td rowSpan={2} style={{"vertical-align": "top"}} onClick={e => this.confirmDeleteIntervalInactiveDate(e, date)}>
                                                       <img style={{"cursor": "pointer"}} width='16' height='16' src='data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABEklEQVQ4ja3TL0tDcRjF8c/GGAO7islgMJgtGg02sdgsFrUumB+jhlVBYW/AGbe9CMFXYBQFMRj8M4YOw353XObVIfMp995zv+fcc3n4lRRMRGzgAvNJesRhRHTG2VKBuYwHdHCZ5C3sYC4i+t8CIqKCOmZQwxGauEvcLA7QwAve0YiIfiUBmzgZK7NX8Hf13P0tWlnAPvooo1dgzE8Ng+RpjdSIOI6I7gSziLiKiFHbSu7dZwJquMY2dlHFGdpYSy0VBWRTxkqqupCu1aRl/CAPTzX/HvDnwLxh8CP1y0embjC+hTI+cIondBPznLReYgq38IZFrBvufMnwFN5jOWmrSX8tatA0PHXtCa1vcJ49fAGn6D8mfzlS/wAAAABJRU5ErkJggg==' /></td>
                                                </tr>
                                                <tr>
                                                    <td style={{"text-align" : "left"}}>{this.getPeriods(date)}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div className="calendar-column-title"
                                             style={this.getColumnStyleColumnTitle(date)}
                                             onClick={e => this.initCroisiere(null, date)}>
                                            {Moment(date).format("dddd")}
                                            <br/>
                                            {Moment(date).format("DD/MM")}
                                        </div>
                                        {this.state.data.croisieres.map(croisiere => (
                                            <React.Fragment>
                                                <Tooltip id={'calendarTooltip' + croisiere.id} anchorSelect={'.calendarTooltip' + croisiere.id} key={croisiere.id} effect={"solid"} openOnClick clickable>
                                                    <div className="calendar-tooltip">
                                                        <div
                                                            className={"boxTitle croisiereStatut-" + croisiere.refCroisiereStatut.id}>{croisiere.clientNom}</div>
                                                        <div className="boxContent">
                                                            <div id="infoIcon-1"
                                                                 className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}</div>
                                                            <br/>
                                                            <div id="infoIcon-2"
                                                                 className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("HH:mm")}</div>
                                                            <br/>
                                                            <div id="infoIcon-3"
                                                                 className="infoIcon">{croisiere?.croisiereRamassage?.label}</div>
                                                            <br/>
                                                            <div id="infoIcon-4"
                                                                 className="infoIcon">{!!croisiere.utilisateur ? croisiere.utilisateur.fullName : ""}</div>
                                                            <div id="infoIcon-6"
                                                                 className="infoIcon">{croisiere.clientTel}</div>
                                                            <br/><br/>

                                                            {this.state.formError &&
                                                            <ul className="errorMessage alignCenter">
                                                                <li><span>{this.state.formError}</span></li>
                                                            </ul>
                                                            }
                                                            <div className="alignCenter">
                                                                {croisiere.refCroisiereStatut.id < 5 &&
                                                                <button type="button" className="validButton"
                                                                        style={{width: "100%", marginBottom: "10px"}}
                                                                        onClick={e => this.initCroisiere(croisiere.id, null)}>Modifier
                                                                    planning</button>
                                                                }
                                                                {croisiere.refCroisiereStatut.id == 8 &&
                                                                <button type="button" className="validButton"
                                                                        style={{width: "100%", marginBottom: "10px"}}
                                                                        onClick={e => this.initCroisiere(croisiere.id, null)}>Modifier
                                                                    planning</button>
                                                                }
                                                                <button type="button" className="validButton" style={{width: "100%", marginBottom: "10px"}}
                                                                        onClick={e => document.location = "/admin/croisiere/" + croisiere.id}>Voir
                                                                    détails
                                                                </button>

                                                                <button type="button" className="validButton"
                                                                        style={{width: "100%"}}
                                                                        onClick={e => this.copyCroisiere(croisiere.id, null)}>Dupliquer
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tooltip>

                                                {croisiere.bateau !== null && croisiere.date !== null && (!this.state.selectedCroisireId || this.state.selectedCroisireId !== croisiere.id || !this.state.formData.croisiereDate) && Moment(croisiere.date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY") === Moment(date).format("DD/MM/YYYY") &&
                                                <div style={this.getBorderStyle(croisiere)}
                                                     className={"calendar-item" + ' ' + this.getCroisiereClass(croisiere.id)} id={'calendarDiv' + croisiere.id}>
                                                    <a key={croisiere.id} onClick={e => this.selectCroisiereUi(croisiere.id)}
                                                       className={'calendarTooltip' + croisiere.id + ' ' + 'calendar-item croisiereStatut-' + croisiere.refCroisiereStatut.id}
                                                       style={this.getItemStyle(croisiere)}
                                                       id={'calendarTooltip' + croisiere.id}>
                                                        {!!croisiere.bateau ? croisiere.bateau.nom.substring(0, 3) : ""}
                                                    </a>
                                                </div>
                                                }
                                                {croisiere.bateau !== null && croisiere.date !== null && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id && !!this.state.formData.croisiereDate && Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY") === Moment(date).format("DD/MM/YYYY") &&
                                                <div style={this.getBorderStyle(croisiere)}
                                                     className={"calendar-item" + ' ' + this.getCroisiereClass(croisiere.id)} id={'calendarDiv' + croisiere.id}>
                                                    <a key={croisiere.id} onClick={e => this.selectCroisiereUi(croisiere.id)}
                                                       className={'calendarTooltip' + croisiere.id + ' ' + 'calendar-item croisiereStatut-' + croisiere.refCroisiereStatut.id}
                                                       style={this.getItemStyle(croisiere)}
                                                       id={'calendarTooltip' + croisiere.id}>
                                                        {!!croisiere.bateau ? croisiere.bateau.nom.substring(0, 3) : ""}
                                                    </a>
                                                </div>
                                                }


                                            </React.Fragment>
                                        ))}
                                        {this.state.displayForm && !this.state.selectedCroisireId && Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY") === Moment(date).format("DD/MM/YYYY") &&
                                        <div style={this.getBorderStyle()} className={"calendar-item"}>
                                            <div className="calendar-item" style={this.getItemStyle()}></div>
                                        </div>
                                        }
                                    </div>
                                ))}

                                <div className="calendar-time" style={this.getCalendarHsStyle(0)}>00h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(0)}>00h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(1)}>01h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(1)}>01h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(2)}>02h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(2)}>02h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(3)}>03h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(3)}>03h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(4)}>04h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(4)}>04h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(5)}>05h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(5)}>05h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(6)}>06h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(6)}>06h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(7)}>07h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(7)}>07h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(8)}>08h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(8)}>08h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(9)}>09h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(9)}>09h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(10)}>10h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(10)}>10h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(11)}>11h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(11)}>11h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(12)}>12h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(12)}>12h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(13)}>13h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(13)}>13h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(14)}>14h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(14)}>14h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(15)}>15h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(15)}>15h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(16)}>16h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(16)}>16h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(17)}>17h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(17)}>17h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(18)}>18h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(18)}>18h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(19)}>19h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(19)}>19h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(20)}>20h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(20)}>20h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(21)}>21h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(21)}>21h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(22)}>22h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(22)}>22h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(23)}>23h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(23)}>23h00</div>
                                <div className="calendar-time" style={this.getCalendarHsStyle(24)}>24h00</div>
                                <div className="calendar-time-right" style={this.getCalendarHsStyle(24)}>24h00</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Calendriers;
